import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Selection } from '../Common/selection';
import { fetchWarehouses, resetWarehouses } from '../../actions/warehouses_actions';

class WarehouseDropdown extends Component {

  state = {
    warehouseOptions: [],
  }

  componentWillMount() {
    this.props.fetchWarehouses(this.props.Company_id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.warehouseList !== nextProps.warehouseList) {
      this.setWarehouseOptions(nextProps.warehouseList);
    }
    if (this.props.Company_id !== nextProps.Company_id && nextProps.Company_id) {
      this.props.fetchWarehouses(nextProps.Company_id);
    }
  }

  componentWillUnmount() {
    this.props.resetWarehouses();
  }

  setWarehouseOptions(warehouses) {
    const warehouseOptions = [];
    if (warehouses) {
      warehouses.map(warehouse => {
        warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
      });
    }
    this.setState({ warehouseOptions });
  }

  render() {
    if (this.props.warehouseListIsLoading && !this.props.fetchWarehousesError) {
      return <Spinner />;
    } else if (this.props.fetchWarehousesError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="warehouse_cannot_be_loaded" />
          </div>
        </ContentWrapper>
      );
    }
    const { warehouseOptions } = this.state;
    return (
      <Field {...this.props} name='Warehouse' component={Selection} options={warehouseOptions} />
    );
  }
}

/*
  arAccounts: {
    accountList,
    accountsIsLoading,
    accountsError,
  }
*/
function mapStateToProps(state) {
  return {
    warehouseList: state.warehouses.all,
    warehouseListIsLoading: state.warehouses.isLoading,
    fetchWarehousesError: state.warehouses.fetchWarehousesError,
  };
}

export default connect(mapStateToProps, {
  fetchWarehouses,
  resetWarehouses,
})(WarehouseDropdown);



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/warehouseDropdown.jsx